<div class="app">
  @if (isAppReady()) {
    <app-header />
    <main class="app__main">
      <router-outlet />
    </main>
  } @else {
    <div class="app__loading">
      <div class="app__loading-spinner"></div>
      <p class="app__loading-text">{{ 'app.loading' | translate }}</p>
    </div>
  }
</div>
